import { put, takeLatest } from "redux-saga/effects";

import { defaultApi } from "../../utils/axiosApi";
import {
  REQUEST_TABLE_DATA,
  REQUEST_TABLE_DATA_FAILURE,
  REQUEST_TABLE_DATA_SUCCESS,
} from "../../utils/constants";

export function* tableDataRequest(action = {}) {
  try {
    const { limit, offset } = action.payload || {};
    const query = limit === undefined && offset === undefined
      ? ""
      : `?limit=${encodeURIComponent(limit ?? 50)}&offset=${encodeURIComponent(offset ?? 0)}`;
    const response = yield defaultApi(`dashboard/leads/all/${query}`, "GET");
    yield put({
      type: REQUEST_TABLE_DATA_SUCCESS,
      payload: { data: response },
    });
  } catch (error) {
    yield put({ type: REQUEST_TABLE_DATA_FAILURE, payload: error });
  }
}

export default function* root() {
  yield takeLatest(REQUEST_TABLE_DATA, tableDataRequest);
}
